import { InjectionToken } from '@angular/core';
import { CisApisConfig } from './cis-apis.config';


export const CIS_APIS_CONFIG = new InjectionToken<CisApisConfig>('CIS_APIS_CONFIG ')